<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>

export default {
  name: "sales-invoice-payment-status-select",
  props: {
    value: {
      type: [String, Array],
      default: undefined
    },
  },
  data() {
    return {
      selected: Array.isArray(this.value) ? this.value[0] : this.value || null,
      options: [
        { value: null, text: this.$t('Please select {something}', { something: this.$t('sale_notes.type') }) },
        { value: 'paid', text: 'Lunas' },
        { value: 'partially', text: 'Kurang Bayar' }
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (!this.lodash.isEqual(val, oldVal)) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
